import { useState, useEffect } from 'react';
import { Grid, Button, CardMedia } from '@mui/material';
import unsplash from '../../api/unsplash';
import { getTokenFromLocalStorage } from '../../utils/localStorageHelpers';
import { useNavigate } from 'react-router-dom';

import GlobalSnackbar from '../Snackbar';
import Safety from '../../assets/images/Safety_sx.png';
import { Hidden } from '@mui/material';

const SetPasswordMedico = () => {
    const [isGood, setIsGood] = useState(true);
    const [passwordShown, setPasswordShown] = useState(false);
    const [openSnack, setOpenSnack] = useState(false);
    const [password, setPassword] = useState(null);
    const snack = {
        severity: 'success',
        messaggio: 'Salvataggio Effettuato correttamente',
        open: false,
    };
    const [icon, setIcon] = useState('bi bi-eye-slash-fill');

    const navigate = useNavigate();

    const handleCloseSnack = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenSnack(false);
    };

    const handleEyeClick = () => {
        setPasswordShown(!passwordShown);
        setIcon(passwordShown ? 'bi bi-eye-slash-fill' : 'bi bi-eye-fill');
    };

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const token = urlParams.get('token');
        async function fetchData() {
            try {
                console.log(token);
                await unsplash.post(
                    'portaleMedici',
                    { operation: 'verifyToken', token: token },
                    {
                        headers: {
                            Authorization: `Bearer ${getTokenFromLocalStorage()}`,
                        },
                    }
                );
                setIsGood(true);
            } catch (error) {
                setIsGood(false);
                console.error('Error while fetching data');
            }
        }
        fetchData();
    }, []);

    const savePassword = async (e) => {
        e.preventDefault();
        const urlParams = new URLSearchParams(window.location.search);
        const token = urlParams.get('token');

        try {
            await unsplash.post(
                'portaleMedici',
                {
                    operation: 'changePassword',
                    token: token,
                    password: password,
                },
                {
                    headers: {
                        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
                    },
                }
            );

            navigate('/AreaMedico/Login');
        } catch (e) {
            //alert("POOOOOO")
        }
    };

    return (
        <>
            <GlobalSnackbar
                severity={snack.severity}
                messaggio={snack.messaggio}
                openSnack={openSnack}
                handleCloseSnack={handleCloseSnack}
            />
            {isGood ? (
                <Grid
                    container
                    spacing={0}
                    direction="row"
                    alignItems="center"
                    display="flex"
                    minHeight="100vh"
                    flexWrap="nowrap"
                >
                    <Hidden mdDown>
                        <Grid
                            item
                            xs={6}
                            sx={{
                                margin: '30px',
                                borderRadius: '8px',
                            }}
                        >
                            <CardMedia
                                sx={{
                                    borderRadius: '8px',
                                    height: 'calc(100vh - 4rem)',
                                }}
                                component="img"
                                image={Safety}
                                alt="Safety"
                            />
                        </Grid>
                    </Hidden>
                    <Grid
                        item
                        xs={8}
                        lg={3}
                        justifyContent="center"
                        alignItems="center"
                        display="flex"
                        flexWrap="wrap"
                        gap={4}
                        style={{ margin: '0 auto' }}
                    >
                        <img
                            src={require('../../assets/images/Logo-ASTM.png')}
                            className="max-w-full h-auto"
                            width="500px"
                            alt="f"
                        />

                        <form
                            //onSubmit={handleLogin}
                            style={{ width: '100%' }}
                        >
                            <label
                                className="form-label fs-5"
                                htmlFor="password"
                            >
                                Password
                            </label>
                            <div className="form-outline mb-4 relative flex items-stretch w-full">
                                <input
                                    type={passwordShown ? 'text' : 'password'}
                                    id="password"
                                    name="password"
                                    placeholder="Inserisci la password"
                                    value={password}
                                    onChange={(e) =>
                                        setPassword(e.target.value)
                                    }
                                    className="block appearance-none w-full  mb-1  text-gray-800 border border-gray-200  py-2 px-4 text-lg leading-normal rounded border-r-0 bg-white fs-6"
                                />
                                <span className="input-group-text bg-transparent">
                                    <i
                                        className={icon}
                                        style={{ cursor: 'pointer' }}
                                        onClick={handleEyeClick}
                                    ></i>
                                </span>
                            </div>

                            <div className="flex justify-around items-center mb-4"></div>

                            <Button
                                type="submit"
                                fullWidth
                                size="large"
                                variant="contained"
                                onClick={savePassword}
                                style={{
                                    padding: '8px 16px',
                                    backgroundColor: '#11526f',
                                }}
                            >
                                CONFERMA{' '}
                            </Button>
                        </form>
                    </Grid>
                </Grid>
            ) : (
                'ATTENZIONE LINK NON PIU VALIDO'
            )}
        </>
    );
};

export default SetPasswordMedico;
